import {createSelector} from 'reselect';

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.createAppointmentRequest);

export const getReception = createSelector(getState, ({reception}) => reception);
export const getTowing = createSelector(getState, ({towing}) => towing);

export const getCustomerInformation = createSelector(getState, ({customer}) => customer);

export const getGeneralInformation = createSelector(getState, ({generalInformation}) => generalInformation);
export const getVin = createSelector(getGeneralInformation, ({vin}) => vin);
export const getBrand = createSelector(getGeneralInformation, ({brand}) => brand);
export const getComment = createSelector(getState, ({comment}) => comment);

export const getDate = createSelector(getState, ({date}) => date);
export const getSelectedDate = createSelector(getDate, (date = {}) => date.selectedDate);
export const getSelectedSlot = createSelector(getDate, (date = {}) => date.selectedSlot);
export const getStartTime = createSelector(getSelectedSlot, (selectedSlot = {}) => selectedSlot.startTime);

export const getChosenMobility = createSelector(getState, ({chosenMobility}) => chosenMobility);
export const getMobilityOption = createSelector(getChosenMobility, (mobility = {}) => mobility.mobilityOption);
export const getMobilitySolution = createSelector(getChosenMobility, (mobility = {}) => mobility.mobilityOptionTitle);

export const getServices = createSelector(getState, ({selectedOptions}) => selectedOptions);



// WEBPACK FOOTER //
// ./src/selectors/createAppointmentRequest.js